import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from 'vue'

interface Props {
  size?: string
  info?: string | null
}


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'InfoIcon'
},
  __name: 'InfoIcon',
  props: {
    size: { default: '1.25rem' },
    info: { default: null }
  },
  setup(__props: any) {





const iconProps = computed(() => ({
  size: __props.size,
  icon: '$information-outline',
  class: [
    'text-secondary-600',
    { 'cursor-pointer': __props.info, 'hover:text-primary-500': __props.info }
  ]
}))

return (_ctx: any,_cache: any) => {
  const _component_VIcon = _resolveComponent("VIcon")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (__props.info)
    ? _withDirectives((_openBlock(), _createBlock(_component_VIcon, _normalizeProps(_mergeProps({ key: 0 }, iconProps.value)), null, 16)), [
        [_directive_tooltip, __props.info]
      ])
    : (_openBlock(), _createBlock(_component_VIcon, _normalizeProps(_mergeProps({ key: 1 }, iconProps.value)), null, 16))
}
}

})